import { datadogRum } from '@datadog/browser-rum';
import { onWebViewTerminated, WebViewTerminatedEvent } from '../../capacitor-plugins/webview-recovery';

export const useWebhookForceReload = () => {
  onWebViewTerminated((event: WebViewTerminatedEvent) => {
    datadogRum.addAction('webview-restart-forced', {
      platform: event.platform,
      reason: event.reason,
      session_duration_sec: Math.round(event.sessionDurationMs / 1000),
      renderer_priority_at_exit: event.rendererPriorityAtExit,
      was_foreground: event.wasForeground,
      ms_since_foreground: event.msSinceForeground,
      device_model: event.deviceModel,
    });
  });
};
